﻿/*グローバルナビ用変数*/
var gMenuOpen = 0;
var gNaviCheck = 0;
var gNaviSpeed = 700;
var gNaviHP = 1070/2;


$(function(){//jQuery
	
	
	
	/*レシピ名センタリング処理*/
	var liMaxH = 25;
	var liLength = $('#dishBox ul li').length;
	for (var i=0; i<liLength; i++) {
		if(liMaxH < $('#dishBox ul li a span').eq(i).height()){
			liMaxH = $('#dishBox ul li a span').eq(i).height();
		}
	}
	for (var i=0; i<liLength; i++) {
		$('#dishBox ul li a span').eq(i).css({ 'height': liMaxH});
	}
	$('#dishBox ul').css({ opacity: "1"});
	
	var liMaxH2 = 25;
	var liLength2 = $('#toppingBox ul li').length;
	for (var i=0; i<liLength2; i++) {
		if(liMaxH2 < $('#toppingBox ul li a span').eq(i).height()){
			liMaxH2 = $('#toppingBox ul li a span').eq(i).height();
		}
	}
	for (var i=0; i<liLength2; i++) {
		$('#toppingBox ul li a span').eq(i).css({ 'height': liMaxH2});
	}
	$('#toppingBox ul').css({ opacity: "1"});
	
	
	//メニュー開閉
	$('#naviOpenButton a, #naviCloseButton a').click(function() {
		$(this).blur();
		var speed = 450;
		if(!gMenuOpen) {
			gMenuOpen = 1;
			$(window).on('touchmove.noScroll', function(e) {
				e.preventDefault();
			});
			$('#globalNavi').animate({'height':'500px'}, speed, 'easeInOutCubic');
			$('#dyy_header').addClass('open');
		} else {
			gMenuOpen = 0;
			$(window).off('.noScroll');
			$('#globalNavi').animate({'height':'0px'}, speed, 'easeInOutCubic');
			$('#dyy_header').removeClass('open');
			gNaviOpen();
		}
		return false;
	});
	
	$('#naviOpenButton2 a').click(function() {
		$(this).blur();
		var speed = 450;
		if(!gMenuOpen) {
			gMenuOpen = 1;
			$(window).on('touchmove.noScroll', function(e) {
				e.preventDefault();
			});
			$('#globalNavi').animate({'height':'500px'}, speed, 'easeInOutCubic');
			$('#dyy_header').addClass('open');
		} else {
			gMenuOpen = 0;
			$(window).off('.noScroll');
			$('#globalNavi').animate({'height':'0px'}, speed, 'easeInOutCubic');
			$('#dyy_header').removeClass('open');
			gNaviOpen();
		}
		return false;
	});
	
	
	/*アバウト*/
	$('#kvButton a').click(function(){
		$('#mask').show();
		$('#aboutWrap').css({'top':$(window).scrollTop()+20});
		$('#aboutWrap').fadeIn();
		return false;
	});
	$('#about').click(function(e){
		e.stopPropagation();
	});
	$('#aboutWrap, #mask').click(function(){
		$('#mask').hide();
		$('#aboutWrap').fadeOut();
		return false;
	});
	
	
	/*トッピング*/
	$('#toppingBox ul li').click(function(){
		$('#mask').show();
		$('#popup iframe').attr('src', $(this).children().attr('href') + '?' + (new Date().getTime()));
		$('#popup iframe').load(function(){
			$('#popupWrap').css({'top':$(window).scrollTop()+70});
			$('#popupWrap').fadeIn();
		});
		return false;
	});
	$('#popupWrap, #mask').click(function(){
		$('#mask').hide();
		$('#popupWrap').fadeOut();
		return false;
	});
	
	
	/*閉じるボタン*/
	$('.closeButton, .closeButton2').click(function(){
		$(this).parent().parent().fadeOut();
		$('#mask').hide();
		return false;
	});
	
	
	/*ブラウザスクロール時の処理*/
	/*ブラウザリサイズ時の処理*/
	$(window).on('load resize scroll',function(){
		var headerHeight = $('#header-bulgaria').outerHeight();
		gNaviOpen(headerHeight);
	});
	
	
});


/*SPヘッダーの処理*/
function gNaviOpen(headerHeight){
	var st = $(window).scrollTop();
	if(gNaviCheck == 0 && gMenuOpen == 0){
		if(st >= gNaviHP && $('#dyy_header').css('top') == '-50px'){
			gNaviCheck = 1;
			$('#dyy_header').animate({top:headerHeight}, gNaviSpeed, 'easeInOutCubic', function(){
				gNaviCheck = 0;
				gNaviOpen();
			});
		}else if(st < gNaviHP && $('#dyy_header').css('top') == headerHeight+'px'){
			gNaviCheck = 1;
			$('#dyy_header').animate({top:-50}, gNaviSpeed, 'easeInOutCubic', function(){
				gNaviCheck = 0;
				gNaviOpen();
			});
		}
	}
}